import React from 'react';

import { Icon } from '@chakra-ui/react';

export const PolicyResourceIcon = props => (
  <Icon viewBox="0 0 723 720" w="full" h="full" color="inherit" {...props}>
    <g transform="translate(-278 0)">
      <g>
        <g>
          <g>
            <g>
              <path
                d="M400.145 642.001 400.145 78C400.145 68.0588 408.204 60 418.144 60L767.692 60C772.463 60 777.041 61.8964 780.416 65.2721L874.874 159.728C878.249 163.104 880.145 167.682 880.145 172.456L880.145 642.001C880.145 651.942 872.087 660 862.144 660L418.144 660C408.204 660 400.145 651.942 400.145 642.001Z"
                stroke="currentColor"
                strokeWidth="20.0126"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="4"
                strokeOpacity="1"
                fill="none"
                fillRule="nonzero"
                transform="matrix(1.00076 0 0 1 -1.06613 0)"
              />
              <path
                d="M760.145 162 760.145 70.6065C760.145 64.7488 764.893 60 770.752 60 773.565 60 776.262 61.1174 778.255 63.1066L877.039 161.894C879.028 163.882 880.145 166.58 880.145 169.393 880.145 175.251 875.398 180 869.536 180L778.144 180C768.204 180 760.145 171.941 760.145 162Z"
                stroke="currentColor"
                strokeWidth="20.0126"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="4"
                strokeOpacity="1"
                fill="currentColor"
                fillRule="nonzero"
                fillOpacity="1"
                transform="matrix(1.00076 0 0 1 -1.06613 0)"
              />
              <path
                d="M731.002 264.301 698.371 247.177C669.728 232.146 655.406 224.63 640 224.63 624.593 224.63 610.272 232.146 581.629 247.177L548.998 264.301C520.061 279.487 503.049 288.414 492.506 300.355L640 374.1 787.494 300.355C776.951 288.414 759.942 279.487 731.002 264.301Z"
                fill="currentColor"
                fillRule="nonzero"
                fillOpacity="1"
                transform="matrix(1.00076 0 0 1 -1.06613 0)"
              />
              <path
                d="M799.046 321.94 652.236 395.343 652.236 549.367C663.948 546.449 677.277 539.456 698.371 528.387L731.002 511.264C766.106 492.841 783.657 483.631 793.405 467.078 803.151 450.528 803.151 429.929 803.151 388.736L803.151 386.828C803.151 355.951 803.151 336.643 799.046 321.94Z"
                fill="currentColor"
                fillRule="nonzero"
                fillOpacity="1"
                transform="matrix(1.00076 0 0 1 -1.06613 0)"
              />
              <path
                d="M627.764 549.367 627.764 395.343 480.954 321.94C476.849 336.643 476.849 355.951 476.849 386.828L476.849 388.736C476.849 429.929 476.849 450.528 486.595 467.078 496.34 483.631 513.894 492.841 548.998 511.264L581.629 528.387C602.723 539.456 616.052 546.449 627.764 549.367Z"
                fill="currentColor"
                fillRule="nonzero"
                fillOpacity="1"
                transform="matrix(1.00076 0 0 1 -1.06613 0)"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </Icon>
);
